import { createColorsContext } from './colors-context-factory';

const { ColorsContext, useColorsContext } = createColorsContext('RunsColorsContextProvider');

export const RunsColorsContext = ColorsContext;
export const useRunsColorsContext = useColorsContext;
